import b1 from "../images/Blogs/blog1.webp";
import b2 from "../images/Blogs/blog2.webp";
import b3 from "../images/Blogs/blog3.webp";
import bl1 from "../images/Blogs/bl1.webp";
import bl2 from "../images/Blogs/bl2.webp";
import bl3 from "../images/Blogs/bl3.webp";
import bl4 from "../images/Blogs/bl4.webp";
import b4 from "../images/Blogs/blog4.webp";
export const blogs = [{
    title: "Top 10 Benefits of Hiring a Private Tutor in Dubai",
    image: bl1,
}, {
    title: "How to Find the Best Tutor Website in Dubai",
    image: bl2,
}, {
    title: "Most Essential Study Tips for Students in Dubai",
    image: bl3,
}, {
    title: "Why Online Tutoring Is Becoming Popular in Dubai",
    image: bl4,
}, {
    title: "Your guide to creating the perfect language learning schedule",
    image: b2,
}, {
    title: "5 best language exchange apps and websites in 2024",
    image: b1,
}, {
    title: "Modern Physics with AI: Revolutionize Your Physics Learning",
    image: b4,
}, {
    title: "6 Key Digital Literacy Tips For Online Tutors To Develop",
    image: b3,
},]